export default __webpack_public_path__ + "static/media/723.256626c7.gif";